import {getMAPIBaseUrl, getDeviceID} from '@stencil/hotels-utils/src/common-utils';

import {hasWebpSupport, getDeviceDetail, getSearchCriteria, getRequestDetails} from './apiUtils';
import {STATIC_BASE_URL} from './apiUrls';
import api from '@stencil/megatron/src/api';
import {getExperimentData} from '@stencil/hotels-utils/src/get-experiment-data';

const deviceDetailsForPwaSSR = ssrDvid => {
  return {
    appVersion: '7.2.5',
    deviceId: ssrDvid || getDeviceID(),
    bookingDevice: 'PWA',
    deviceType: 'MOBILE',
  };
};

export const prepareStaticDetailRequest = ({requestObj, pokus}) => {
  const {
    urlParams = {},
    comparatorHotelIds,
    uuids,
    pwaSsr,
    requiredApis = null,
    flavour,
    cmpValue = '',
    sessionIdValue = '',
    deviceIdVal = '',
  } = requestObj;
  const filterCriteria = []; // getMatchmakerAndFiltersApplied(urlParams);
  let imageFormat = 'jpg';
  if (hasWebpSupport()) {
    imageFormat = 'webp';
  }
  const desktopImgSizeFactorDetail = 1; // get(pokus, 'pokusData.metadataValues.desktopImgSizeFactorDetail', 1);
  const isDesktop = flavour === 'desktop';

  return {
    deviceDetails: getDeviceDetail(isDesktop),
    expData: getExperimentData({pokus}),
    featureFlags: {
      locus: true,
      noOfAddons: 2,
      noOfCoupons: 3,
      noOfPersuasions: 2,
      noOfSoldouts: 1,
      bestOffersLimit: 3,
      reviewSummaryRequired: true,
      shortlistingRequired: true,
      staticData: true,
      walletRequired: true,
      unmodifiedAmenities: true,
    },
    imageDetails: {
      categories: [
        {
          count: 100,
          imageFormat,
          type: 'H',
          height: isDesktop ? 350 * desktopImgSizeFactorDetail : 238,
          width: isDesktop ? 520 * desktopImgSizeFactorDetail : 350,
        },
        {
          count: 100,
          height: isDesktop ? 350 * desktopImgSizeFactorDetail : 238,
          imageFormat,
          type: 'R',
          width: isDesktop ? 520 * desktopImgSizeFactorDetail : 350,
        },
      ],
      types: ['professional', 'traveller'],
    },
    requestDetails: getRequestDetails({urlParams, cmpValue, sessionIdValue, deviceIdVal}),
    filterCriteria,
    requiredApis: requiredApis,
    reviewDetails: {
      otas: ['MMT', 'TA', 'MANUAL', 'OTHER', 'EXT'],
      tagTypes: ['BASE', 'WHAT_GUESTS_SAY'],
    },
    searchCriteria: getSearchCriteria({urlParams, comparatorHotelIds}),
    uuids: uuids || [],
  };
};

export const fetchStaticDetailsData = async ({staticDetailsRequest = {}, client = 'DESKTOP'}) => {
  return await api.post(
    getMAPIBaseUrl(),
    STATIC_BASE_URL.replace(':client', client),
    staticDetailsRequest,
    true,
  );
};
